import { useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { capitalize } from "lodash";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";

const FormStatusAlert = ({
  status,
  open,
  handleClose,
  formId,
  fetchData,
  beforeStatusChange,
}) => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleCloseDialog = () => {
    handleClose();
    setError("");
  };
  const handleConfirm = async () => {
    setLoading(true);
    setError("");
    try {
      if (status === "active" && beforeStatusChange) {
        const saveSucceeded = await beforeStatusChange();

        if (saveSucceeded === false) {
          throw new Error("Failed to save form changes before finalizing");
        }
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/forms/change-status`,
        {
          formId,
          currentSession,
          status,
        },
        {
          withCredentials: true,
        },
      );

      if (response?.data?.success) {
        fetchData();
        handleCloseDialog();
      }
    } catch (error) {
      setError(
        error?.response?.data?.message ||
          error?.message ||
          `An error occurred while changing form status`,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
      <DialogContent>
        <Typography variant="body1">
          {`Are you sure you want to ${status} this form?`}
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCloseDialog}
          disabled={loading}
          variant="outlined"
        >
          Cancel
        </Button>
        <LoadingButton
          loading={loading}
          onClick={handleConfirm}
          variant="contained"
          color="error"
        >
          {capitalize(status)}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default FormStatusAlert;
